// extracted by mini-css-extract-plugin
module.exports = {"table":"NoShippingCosts_table__1hWs3","note":"NoShippingCosts_note__2ZME0"};